import React, { useEffect, useRef, useState } from "react"

const CountDownTimer = props => {
  const {
    initialTime = null,
    onTimeout = () => { },
    zeroPads = {
      seconds: false,
      minutes: false,
      hours: false,
      days: false
    },
    show = {
      seconds: true,
      minutes: true,
      hours: false,
      days: false
    },
    ...otherProps
  } = props

  const [time, setTime] = useState(null)

  const interval = useRef()
  const timeDistance = useRef(Date.now() + initialTime * 1000)

  const getTimeString = () => {
    const timer =
      Math.max(Math.floor((timeDistance.current - Date.now()) / 1000) + 1, 0)

    if (timer === 0) {
      onTimeout()

      return clearInterval(interval.current)
    }

    const days = parseInt(timer / (60 * 60 * 24), 10)
    let hours = parseInt((timer % (60 * 60 * 24)) / (60 * 60), 10)
    let minutes = parseInt((timer % (60 * 60)) / (60), 10)
    let seconds = parseInt(timer % 60, 10)

    hours = zeroPads.hours ?
      hours < 10 ? "0" + hours : hours : hours
    minutes = zeroPads.minutes ?
      minutes < 10 ? "0" + minutes : minutes : minutes
    seconds = zeroPads.seconds ?
      seconds < 10 ? "0" + seconds : seconds : seconds

    let string = ""

    if (show.days) string += `${days} Day${days > 1 ? "s" : ""} ${days > 1 ? "and " : ""}`
    if (show.hours) string += `${hours}:`
    if (show.minutes) string += `${minutes}:`
    if (show.seconds) string += `${seconds}`

    setTime(string)
  }

  const startCountdown = () => {
    if (initialTime <= 0) return

    getTimeString()

    interval.current =
      setInterval(getTimeString, 1000)
  }

  useEffect(() => {
    startCountdown()

    return () => clearInterval(interval.current)
  }, [])

  return (
    <div {...otherProps}>
      {
        time !== null &&
        <span>{time}</span>
      }
    </div>
  )
}

export default CountDownTimer